import { useMemo } from 'react';
import flatMap from 'lodash/flatMap';
import { PostDTO, useNewsfeedQuery } from './api/useNewsfeedQuery';
import { InfiniteAsyncComponentHookResult } from '../Types/ComponentHookResult';

interface UseNewsfeed {
  feature: PostDTO[];
  news: PostDTO[];
}

export const useNewsfeed = (): InfiniteAsyncComponentHookResult<UseNewsfeed | null> => {
  const queryInfo = useNewsfeedQuery();

  const data = useMemo(() => {
    if (!queryInfo.data) {
      return null;
    }

    const { pages } = queryInfo.data;

    const newsList = flatMap(pages, ({ posts }) => posts);

    if (newsList.length === 0) {
      return null;
    }

    return newsList.reduce(
      (acc, post) => ({
        ...acc,
        ...(post.isNew ? { feature: [...acc.feature, post] } : { news: [...acc.news, post] }),
      }),
      { feature: [] as PostDTO[], news: [] as PostDTO[] },
    );
  }, [queryInfo]);

  return {
    ...queryInfo,
    data,
  };
};
